import axios from 'axios';

import * as actionTypes from './actionTypes';
import {backendEndpoint, verifyPathname} from '../utility';
import { Alert } from 'react-bootstrap';

export const scheduleGet = (calendar_id) => {
    return (dispatch) => {
        let url = backendEndpoint + 'calendar/' + calendar_id + '/get_availabilties/';
        let availabilities = [];
        let calendar_meta = {};
        axios.get(url)
            .then(function (response) {
                availabilities = response.data.availabilities;
                calendar_meta = response.data.calendar_meta;
                let friend_calendar_id = (verifyPathname('schedule')) ? calendar_id : null;
                dispatch(scheduleGetSucceeded(availabilities, calendar_id, calendar_meta, friend_calendar_id));
            })
            .catch(function (error) {
                console.log(error);
            });
    }
};

export const scheduleGetSucceeded = (availabilities, calendar_id, calendar_meta, friend_calendar_id) =>{
    return {
        type: actionTypes.SCHEDULE_GET,
        availabilities: availabilities,
        calendar_meta: calendar_meta,
        calendar_id: calendar_id,
        friend_calendar_id: friend_calendar_id
    };
}

export const schedulePick = (selected_availability) => {
    return {
        type: actionTypes.SCHEDULE_PICK,
        selected_availability: selected_availability,
    };
};

export const scheduleSelect = (selected_availability) => {
    return {
        type: actionTypes.SCHEDULE_SELECT,
        selected_availability: selected_availability,
    };
};

export const scheduleBook = (calendar_id, selectedTimestamp, info) => {
    return dispatch => {
        let url = backendEndpoint + 'calendar/' + calendar_id + '/book/';
        let bookData = {
            due_timestamp: selectedTimestamp,
            meta: info
        }
        axios.post(url, bookData)
            .then(response => {
                let last_booked_appointment = response.data.data.booked_appointment;
                dispatch(scheduleBookConfirm(last_booked_appointment));
            })
            .catch(err => {
                Alert.error('booking failed');
            });
    }
}

export const scheduleBookConfirm = (last_booked_appointment) => {
    return {
        type: actionTypes.SCHEDULE_BOOK,
        last_booked_appointment: last_booked_appointment
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/schedule.js